<div class="auth-toggle">
  <button
    type="button"
    class="auth-toggle__btn"
    [class.auth-toggle__btn--active]="leftIsActive()"
    (click)="toggleLeft()"
  >
    {{ 'app.auth.signUp' | translate }}
  </button>
  <button
    type="button"
    class="auth-toggle__btn"
    [class.auth-toggle__btn--active]="!leftIsActive()"
    (click)="toggleRight()"
  >
    {{ 'app.auth.signIn' | translate }}
  </button>
</div>
